export const AUTH_DATA_USER = 'AUTH_DATA_USER';
export const AUTH_DATA_LOGIN = 'AUTH_DATA_LOGIN';
export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const CHECK_CREATE_NEW_CLIENT = 'CHECK_CREATE_NEW_CLIENT';
export const SAVE_TYPE_FORM = 'SAVE_TYPE_FORM';
export const CHECK_SWITCH_AUTH_FORM = 'CHECK_SWITCH_AUTH_FORM'
export const CHECK_CHANGE_PASSWORD = 'CHECK_CHANGE_PASSWORD'